export const SCRIPT_ID = "givingtech-embed-js";
export const SCRIPT_SRC =
  "https://secureddonation.com/Content/js/givingtech-embed.js";

